<template>
  <div class="main">
      <div class="toptab">
          <div class="tabBtn" :class="select=='1'?'active':''" @click="selectComponents('1')">工程体系</div>
          <div class="tabBtn" :class="select=='2'?'active':''" @click="selectComponents('2')">服务申请</div>
          <div class="tabBtn" :class="select=='3'?'active':''" @click="selectComponents('3')">常见问题</div>
      </div>
      <transition name="component-fade" mode="out-in">
        <ComtentA v-if="select==3"></ComtentA>
      </transition>
      <transition name="component-fade" mode="out-in">
        <ComtentB v-if="select==1"></ComtentB>
      </transition>
      <transition name="component-fade" mode="out-in">
        <ComtentC v-if="select==2"></ComtentC>
      </transition>
  </div>
</template>
<script>
import ComtentA from '@/components/useQuestion'
import ComtentB from '@/components/engineering'
import ComtentC from '@/components/sapplication'
export default {
  data() {
    return {
      content:"",
      select:"1"
    };
  },
  components: {ComtentA,ComtentB,ComtentC},
  mounted: function() {

  },
  methods: {
      selectComponents:function(e){
          this.select = e
      }
  },
  computed: {}
};
</script>
<style lang="css" scoped>
.main {
  width: 100%;
  position: relative;
  top: 0;
  padding-top: 150px;
  background-color: #f3f4f2;
}
.toptab {
 width:900px;
 margin:0 auto;
 display: flex;
 flex-flow: row nowrap;
 justify-content: flex-start;
}
.toptab .active{
    border:1px solid #ef653d;

}
.tabBtn{
    color: #ef653d;
    font-size: 20px;
    font-weight: 600;
    margin-right: 50px;
    padding:5px 8px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
}
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/parentsCare.vue